<template>
    <div class="h-full bg-gray-200">
        <download-banner v-if="showDownload" />

        <out-put-page ref="cover" :noPadding="true" :fullHeight="true">
            <template v-slot:noPadding>
                <cover
                    :entrepriseName="bpi.entreprise_info.name"
                    :finalYear="cuurentYear + 5"
                    :cuurentYear="cuurentYear"
                />
            </template>
        </out-put-page>
        <out-put-page
            ref="executive_summary"
            title="Nous et notre projet"
            :fullHeight="true"
        >
            <section id="executive-summary">
                <div class="executive-summary-content">
                    <h3>Executive summary</h3>
                    <p>
                        Notre activité a pour objectif «
                        {{ getActivety(bpi.project_info.activity).text }}
                        ». {{ bpi.project_info.description }}. Notre équipe est
                        composée de
                        <span
                            v-for="fonction in bpi.moyens_humains"
                            :key="fonction.code"
                        >
                            {{
                                fonction.value +
                                    " " +
                                    fonction.name.toLowerCase() +
                                    " "
                            }} </span
                        >. Nous comptons réaliser un chiffre d’affaire de
                        {{
                            formatPrice(
                                bpi.chiffres_d_affaires_previsionnels.total
                            )
                        }}
                        de Dirhams. Afin de pouvoir mener à bien notre mission
                        et atteindre nos objectifs, nous envisageons nous baser
                        sur un programme d'investissement qui s'élève à
                        {{
                            formatPrice(bpi.investors_programme.capital)
                        }}
                        Dirhams.
                    </p>
                </div>
            </section>

            <section>
                <h3>Profils des investisseurs</h3>
                <investors-cards :investors="bpi.investors_profiles" />
            </section>
        </out-put-page>

        <nous-et-notre-projet
            :entrepriseInfo="bpi.entreprise_info"
            :projectInfo="bpi.project_info"
            :clients="bpi.clients_info"
            :sellers="bpi.sellers_info !== undefined ? bpi.sellers_info : []"
            :offers="bpi.offers"
        />
        <etude-de-marche :etudeMarcherUrls="etudeMarcherUrls" />

        <itmo
            :itmo="bpi.itmo"
            :moyensFonciersEtImmeubles="bpi.Moyens_fonciers_et_immeubles"
        />

        <PIAndPF :investorProgramme="bpi.investors_programme" />
        <charge-externes-and-c-a
            :chargesExternes="bpi.charge_previsonnel.autreCharge"
            :tauxEvolutionDesCharges="bpi.charge_previsonnel.tauxEvolution"
            :chiffreDAffaires="bpi.chiffres_d_affaires_previsionnels"
            :cpc="bpiOutPut.cpc"
        />
        <CAAndAP :cpc="bpiOutPut.cpc" :currentYear="cuurentYear" />
        <dotations-aux-amortissments
            :outPutData="bpiOutPut"
            :investorProgramme="bpi.investors_programme"
        />
        <cpc :outPutData="bpiOutPut" />
    </div>
</template>

<script>
import Vue from "vue";
import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

import isEmpty from "lodash/isEmpty";
import { storage } from "@/services/firebase.service";

import Cover from "./components/Cover";

import { OutputHelpers } from "@/mixins/OutputMixin.js";
import OutPutPage from "./components/OutPutPage";
import InvestorsCards from "./components/investorsCards";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import NousEtNotreProjet from "./steps/nousEtNotreProjet.vue";
import Itmo from "./steps/ITMO.vue";
import PIAndPF from "./steps/PIAndPFVS";
import DotationsAuxAmortissments from "./steps/DotationsAuxAmortissements";
import cpc from "./steps/cpc";
import CAAndAP from "./steps/CAAndAP";
import chargeExternesAndCA from "./steps/chargesExternesAndCA";
import EtudeDeMarche from "./steps/EtudeDeMarche";
import DownloadBanner from "./components/downloadBanner.vue";
import NProgress from "nprogress";

export default {
    components: {
        cpc,
        CAAndAP,
        Cover,
        OutPutPage,
        EtudeDeMarche,
        InvestorsCards,
        NousEtNotreProjet,
        Itmo,
        PIAndPF,
        DotationsAuxAmortissments,
        chargeExternesAndCA,
        DownloadBanner
    },
    mixins: [OutputHelpers],
    props: {
        bpi: {
            type: Object,
            required: true
        },
        bpiOutPut: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showDownload: false,

            length: 1,
            optionsTauxAmmortissement: {
                labels: [
                    "Immobilisations en non-valeur",
                    "Immobilisations incorporelles",
                    "Immobilisations corporelles",
                    "Divers et imprevue"
                ],
                colors: ["#9fb7c4", "#568297", "#265e7a", "#0a354b", "#041720"],
                chart: {
                    width: 2,
                    type: "donut"
                },
                plotOptions: {
                    pie: {
                        // customScale: 0.3,
                        donut: {
                            labels: {
                                show: false,
                                name: {},
                                total: {
                                    show: true,
                                    label: "Total",
                                    color: "#373d3f",
                                    formatter: function(w) {
                                        return w.globals.seriesTotals.reduce(
                                            (a, b) => {
                                                return a + b;
                                            },
                                            0
                                        );
                                    }
                                }
                            }
                        }
                    }
                },
                legend: {
                    formatter: function(seriesName, opts) {
                        return [
                            seriesName,
                            " - ",
                            opts.w.globals.series[opts.seriesIndex],
                            " DH"
                        ];
                    }
                }
            },
            optionsPlanFinancement: {
                labels: [
                    "Capital social",
                    "Apport en comptes courants associés",
                    "Leasing",
                    "Crédit bancaire"
                ],
                colors: ["#9fb7c4", "#568297", "#265e7a", "#0a354b", "#041720"],
                chart: {
                    width: 1,
                    type: "donut"
                },
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                show: false,
                                name: {},
                                total: {
                                    show: true,
                                    label: "Total",
                                    color: "#373d3f",
                                    formatter: function(w) {
                                        return w.globals.seriesTotals.reduce(
                                            (a, b) => {
                                                return a + b;
                                            },
                                            0
                                        );
                                    }
                                }
                            }
                        }
                    }
                },
                legend: {
                    formatter: function(seriesName, opts) {
                        return [
                            seriesName,
                            " - ",
                            opts.w.globals.series[opts.seriesIndex],
                            " DH"
                        ];
                    }
                }
            },
            seriesTauxAmmortissement: [],
            seriesPlanFinancement: [],
            ChiffreDaffaireSeries: [
                {
                    name: "Chiffre d'affaires (DH)",
                    data: []
                }
            ],
            AchatPrevSeries: [
                {
                    name: "Achats prévisionnels (DH) ",
                    data: []
                }
            ],
            chartOptionsChiffreDaffaire: {
                dataLabels: {
                    enabled: true,
                    formatter: val => {
                        return this.formatPrice(val);
                    }
                },
                grid: { padding: { right: 50, left: 0 } },
                chart: {
                    toolbar: {
                        show: false
                    },
                    type: "area",
                    stacked: false
                },
                stroke: {
                    width: [1],
                    curve: "straight"
                },

                plotOptions: {},

                fill: {
                    opacity: [0.85, 0.25, 1],
                    gradient: {
                        inverseColors: false,
                        shade: "light",
                        type: "vertical",
                        opacityFrom: 0.85,
                        opacityTo: 0.55,
                        stops: [0, 100, 100, 100]
                    }
                },
                labels: [],
                markers: {
                    size: 0
                },
                xaxis: {
                    type: "datetime"
                },
                yaxis: {
                    title: {
                        text: "Chiffre d'affaires prévisionnel (DH) "
                    },
                    tickAmount: 10,
                    min: 0,

                    labels: {
                        formatter: value => {
                            return this.formatPrice(value);
                        }
                    }
                },
                tooltip: {
                    shared: true,
                    intersect: false,
                    y: {
                        formatter: function(y) {
                            if (typeof y !== "undefined") {
                                return y.toFixed(2) + " dh";
                            }
                            return y;
                        }
                    }
                }
            },
            chartOptionsAchatPrev: {
                dataLabels: {
                    enabled: true,
                    formatter: val => {
                        return this.formatPrice(val);
                    }
                },
                grid: {
                    padding: {
                        right: 50
                    }
                },
                chart: {
                    toolbar: {
                        show: false
                    },
                    type: "area",
                    stacked: false
                },
                stroke: {
                    width: [1],
                    curve: "straight"
                },
                plotOptions: {},

                fill: {
                    opacity: [0.85, 0.25, 1],
                    gradient: {
                        inverseColors: false,
                        shade: "light",
                        type: "vertical",
                        opacityFrom: 0.85,
                        opacityTo: 0.55,
                        stops: [0, 100, 100, 100]
                    }
                },
                labels: [],
                markers: {
                    size: 0
                },
                xaxis: {
                    type: "datetime",
                    tickAmount: 10
                },
                yaxis: {
                    title: {
                        text: "Achats prévisionnel (DH) "
                    },
                    min: 0,
                    labels: {
                        formatter: value => {
                            return this.formatPrice(value);
                        }
                    }
                },
                tooltip: {
                    shared: true,
                    intersect: false,
                    y: {
                        formatter(y) {
                            if (typeof y !== "undefined") {
                                return y.toFixed(2) + " points";
                            }
                            return y;
                        }
                    }
                }
            },
            cuurentYear: null,

            etudeMarcherUrls: {
                evolutionMarche: [],
                santeFinanciere: [],
                acteurPartMarcher: [],
                analyseConcurenciel: [],
                GeographicalDistribution: []
            }
        };
    },
    created() {
        NProgress.start();

        if (this.bpiOutPut !== null) {
            this.init();
        } else {
            this.$store.watch(
                state => {
                    return state.user;
                },
                () => {
                    this.init();
                },
                {
                    deep: true
                }
            );
        }

        const storageRef = storage.ref();

        let fileListRef = storageRef.child(
            `/market-research/simplified-version/${
                this.getActivety(this.bpi.project_info.activity).temp_id
            }`
        );
        fileListRef.listAll().then(res => {
            let promises = [];
            res.items.forEach(file => promises.push(file.getDownloadURL()));
            Promise.all(promises)
                .then(results => {
                    const files = results.map((result, index) => ({
                        fileName: res.items[index].location.path_.split("/")[3],
                        url: result
                    }));
                    this.etudeMarcherUrls.evolutionMarche = files.filter(
                        file => file.fileName.split(".")[0] === "1"
                    );
                    this.etudeMarcherUrls.analyseConcurenciel = files.filter(
                        file => file.fileName.split(".")[0] === "2"
                    );
                    this.etudeMarcherUrls.GeographicalDistribution = files.filter(
                        file => file.fileName.split("_")[0] === "3"
                    );
                    this.showDownload = true;

                    NProgress.done();
                })
                .catch(error => console.log(error));
        });
    },

    methods: {
        init() {
            if (this.bpiOutPut !== null) {
                this.cuurentYear = new Date(
                    this.bpiOutPut.generatedDate.seconds * 1000
                ).getFullYear();

                this.optionsTauxAmmortissement.labels = [
                    "Immobilisations en non-valeur",
                    "Immobilisations incorporelles",
                    "Immobilisations corporelles",
                    "Divers et imprevue"
                ];

                this.seriesTauxAmmortissement.push(
                    this.bpi.investors_programme.nonValueAssetTotal
                );
                this.seriesTauxAmmortissement.push(
                    this.bpi.investors_programme.intangibleAssetsTotal
                );

                this.seriesTauxAmmortissement.push(
                    this.bpi.investors_programme.tangibleAssetsTotal
                );

                this.seriesTauxAmmortissement.push(
                    this.bpi.investors_programme.diversImprevue
                        ? this.bpi.investors_programme.diversImprevue
                        : 0
                );

                this.seriesPlanFinancement.push(
                    this.bpi.investors_programme.capitalSocial === null
                        ? 0
                        : this.bpi.investors_programme.capitalSocial
                );
                this.seriesPlanFinancement.push(
                    this.bpi.investors_programme.compteAssocie === null
                        ? 0
                        : this.bpi.investors_programme.compteAssocie
                );
                this.seriesPlanFinancement.push(
                    this.bpi.investors_programme.leasing === null ||
                        this.bpi.investors_programme.leasing === undefined
                        ? 0
                        : this.bpi.investors_programme.leasing
                );
                this.seriesPlanFinancement.push(
                    this.bpi.investors_programme.creditBancaire.montant === null
                        ? 0
                        : this.bpi.investors_programme.creditBancaire.montant
                );
                this.bpiOutPut.cpc.forEach((elem, index) => {
                    this.chartOptionsAchatPrev.labels.push(
                        `${this.cuurentYear + index}`
                    );
                    this.chartOptionsChiffreDaffaire.labels.push(
                        `${this.cuurentYear + index}`
                    );
                    this.ChiffreDaffaireSeries[0].data.push(elem.chifreAffaire);
                    this.AchatPrevSeries[0].data.push(elem.achatsPrevisionnel);
                });
            }
        },

        async DownloadDF() {
            const doc = new jsPDF({
                unit: "pt",
                format: "a4"
            });
            document.html2canvas = html2canvas;
            let pages = document.querySelectorAll(".page");
            for (const [index, page] of pages.entries()) {
                let isLandScape = page.classList
                    .toString()
                    .includes("landscape");
                if (index !== 0) {
                    if (isLandScape) {
                        await doc.addPage("a4", "l");
                    } else {
                        await doc.addPage("a4", "p");
                    }
                }
                let pageCanvas = await html2canvas(page, {
                    dpi: 144,
                    scale: 2,
                    useCORS: true,
                    removeContainer: true
                });

                let pageImg = await pageCanvas.toDataURL("image/jpeg", 1);

                if (isLandScape) {
                    await doc.addImage({
                        imageData: await pageImg,
                        format: "JPEG",
                        x: -9,
                        y: 0,
                        height: 605,
                        width: 842.25,
                        compression: "NONE"
                    });
                } else {
                    await doc.addImage({
                        imageData: await pageImg,
                        format: "JPEG",
                        x: -9,
                        y: 0,
                        height: 842.25,
                        width: 605,
                        compression: "NONE"
                    });
                }
            }

            await doc.save("sample.pdf");
        }
    },

    computed: {
        getActivety() {
            return id =>
                this.$store.state.forms.VotreProject.Sectors.filter(
                    elem => elem.value == id
                )[0];
        }
    }
};
</script>

<style src="@/assets/styles/output2.css" />

<style scoped></style>
